import React from 'react';
import { Typography } from '../../components';
import classNames from 'classnames';

const { Paragraph: AntParagraph } = Typography;

/**
 * @param {'small' | 'base' | 'large'} size
 * @param {'secondary' | 'light' | 'muted' | 'primaryBlue'} color
 * @param {boolean} bold
 * @param {boolean} semiBold
 * @param {boolean} extraBold
 * @param {boolean} xxlBold
 */
export const Paragraph = ({ size, color, bold, semiBold, extraBold, xxlBold, className, ...rest }) => {
    const classes = classNames(
        {
            small: size === 'small',
            large: size === 'large',
            bold: bold,
            'semi-bold': semiBold,
            'extra-bold': extraBold,
            'xxl-bold': xxlBold,
            secondary: color === 'secondary',
            'text-light': color === 'light',
            'text-muted': color === 'muted',
            'text-primary-blue': color === 'primaryBlue',
        },
        className,
    );

    return <AntParagraph className={classes || undefined} {...rest} />;
};
